import React, { useEffect, useRef } from 'react';

export default function Carte({ lat, lon, lieu }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (!lat || !lon) return;
    if (initialized.current) return;
    initialized.current = true;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(link);

    const initMap = () => {
      if (mapInstanceRef.current) return;
      const L = window.L;
      if (!L || !mapRef.current) return;

      try {
        const map = L.map(mapRef.current, {
          center: [lat, lon],
          zoom: 15,
          zoomControl: false,
          dragging: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© OpenStreetMap'
        }).addTo(map);

        const icon = L.divIcon({
          html: `<div style="background:#3D9A6A;width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:1.2rem;box-shadow:0 4px 12px rgba(61,154,106,0.5);border:3px solid white;">📍</div>`,
          className: '',
          iconSize: [36, 36],
          iconAnchor: [18, 18],
        });

        L.marker([lat, lon], { icon }).addTo(map).bindPopup(`<strong>${lieu}</strong>`).openPopup();
        mapInstanceRef.current = map;
      } catch (e) {
        console.log('Map init error:', e);
      }
    };

    if (window.L) {
      initMap();
    } else {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = initMap;
      document.head.appendChild(script);
    }

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
        initialized.current = false;
      }
    };
  }, [lat, lon, lieu]);

  if (!lat || !lon) return (
    <div style={{ background: 'linear-gradient(135deg, #C8E6C9, #A5D6A7)', borderRadius: 24, height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontSize: '2rem' }}>📍</div>
      <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#1C2B1E' }}>{lieu}</div>
    </div>
  );

  return (
    <div style={{ position: 'relative', borderRadius: 24, overflow: 'hidden', height: 180, boxShadow: '0 4px 20px rgba(28,43,30,0.1)' }}>
      <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(to top, rgba(28,43,30,0.7), transparent)', padding: '12px 16px', zIndex: 1000 }}>
        <div style={{ fontSize: '0.78rem', fontWeight: 700, color: 'white' }}>📍 {lieu}</div>
      </div>
      <a href={`https://maps.google.com/?q=${lat},${lon}`} target="_blank" rel="noopener noreferrer" style={{ position: 'absolute', top: 10, right: 10, background: 'white', borderRadius: 100, padding: '6px 12px', fontSize: '0.72rem', fontWeight: 700, color: '#3D9A6A', textDecoration: 'none', zIndex: 1000, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
        Ouvrir Maps →
      </a>
    </div>
  );
}